import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import AnalogySection from './components/AnalogySection';
import CostCalculator from './components/CostCalculator';
import ComparisonMatrix from './components/ComparisonMatrix';
import MigrationStories from './components/MigrationStories';
import TechnicalDeepDive from './components/TechnicalDeepDive';
import ReadinessAssessment from './components/ReadinessAssessment';

const OpenSourceAdvantage = () => {
  return (
    <>
      <Helmet>
        <title>Open-Source AI Advantage | AI Clean Core - Enterprise AI Independence</title>
        <meta 
          name="description" 
          content="Discover why open-source AI is the superior enterprise choice. Calculate your savings, compare solutions, and see real migration success stories. Stop renting your competitive advantage." 
        />
        <meta name="keywords" content="open source AI, enterprise AI, vendor lock-in, AI cost savings, proprietary AI alternatives" />
        <meta property="og:title" content="Open-Source AI Advantage | AI Clean Core" />
        <meta property="og:description" content="Own your AI destiny instead of renting it. See why leading enterprises choose open-source AI for strategic advantage." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/open-source-advantage" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16 lg:pt-20">
          <HeroSection />
          <AnalogySection />
          <CostCalculator />
          <ComparisonMatrix />
          <MigrationStories />
          <TechnicalDeepDive />
          <ReadinessAssessment />
        </main>

        {/* Footer */}
        <footer className="bg-brand-primary text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-4 gap-8">
              <div className="md:col-span-2">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-10 h-10 bg-gradient-to-br from-brand-secondary to-brand-accent rounded-lg flex items-center justify-center">
                    <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="currentColor">
                      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                    </svg>
                  </div>
                  <div>
                    <div className="text-xl font-bold">AI Clean Core</div>
                    <div className="text-sm text-blue-200">Enterprise AI Independence</div>
                  </div>
                </div>
                <p className="text-blue-100 mb-4 max-w-md">
                  Helping enterprises achieve AI sovereignty through open-source solutions. 
                  Own your AI destiny, don't rent it.
                </p>
              </div>
              
              <div>
                <h4 className="font-semibold mb-4">Solutions</h4>
                <ul className="space-y-2 text-blue-200">
                  <li><a href="/ai-core-blueprint" className="hover:text-white transition-colors">AI Core Blueprint</a></li>
                  <li><a href="/services-implementation" className="hover:text-white transition-colors">Implementation Services</a></li>
                  <li><a href="/case-studies-proof" className="hover:text-white transition-colors">Success Stories</a></li>
                </ul>
              </div>
              
              <div>
                <h4 className="font-semibold mb-4">Resources</h4>
                <ul className="space-y-2 text-blue-200">
                  <li><a href="/resources-hub" className="hover:text-white transition-colors">Resource Hub</a></li>
                  <li><a href="/get-started" className="hover:text-white transition-colors">Get Started</a></li>
                  <li><a href="/about-ai-clean-core" className="hover:text-white transition-colors">About Us</a></li>
                </ul>
              </div>
            </div>
            
            <div className="border-t border-blue-800 mt-8 pt-8 text-center text-blue-200">
              <p>&copy; {new Date()?.getFullYear()} AI Clean Core. All rights reserved. Built with open-source technologies.</p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default OpenSourceAdvantage;